<template>
  <div
    v-if="hideRouteForMobile"
    class="flex items-center justify-center text-center full-height"
  >
    <div class="flex column justify-center items-center">
      <img
        src="/blog-logo.svg"
        alt="FunKITools Blog"
        class="q-pa-lg cursor-pointer"
      >
      <q-icon
        name="far fa-laptop-mobile"
        size="6em"
        color="grey-6"
        class="q-my-lg"
      />
      <div class="q-pa-xl">{{ $t('text.onlyDesktop') }}</div>
    </div>
  </div>
  <q-no-ssr
    v-else
    class="full-height"
  >
    <router-view/>
    <CreateContentDialog
      v-if="showCreateContentDialog"
      :keyword="selectedKeyword"
      @hide="onHideCreateContentDialog"
    />
    <CreateEmptyPostDialog
      v-if="showCreateEmptyPostDialog"
      :keyword="selectedKeyword"
      @hide="onHideCreateEmptyPostDialog"
    />
  </q-no-ssr>
</template>
<script setup>
import { computed, inject, ref } from 'vue';
import { useMeta, useQuasar } from 'quasar';
import { useBlogStore } from 'src/stores/blog';

import { useAppStore } from 'stores/app';
import CreateContentDialog from 'components/dialog/CreateContentDialog.vue';
import CreateEmptyPostDialog from 'components/dialog/CreateEmptyPostDialog.vue';
import { ROUTES } from 'src/enums';
import { useRoute } from 'vue-router';

useMeta({ title: 'FunKITools' });
const blogStore = useBlogStore();

const $q = useQuasar();
const route = useRoute();

const isMobile = computed(() => $q.platform.is.mobile);
const excludedRoutes = [
  ROUTES.AUTH,
  ROUTES.RESET,
  ROUTES.RECOVERY,
  ROUTES.MY.BOOK,
  ROUTES.MY.PROFILE,
  ROUTES.MY.PURCHASE_HISTORY,
];
const hideRouteForMobile = computed(() => isMobile.value && !excludedRoutes.includes(route.name));

defineOptions({
  // eslint-disable-next-line consistent-return
  preFetch({ store }) {
    const appStore = useAppStore(store);
    if (!appStore.layout) {
      try {
        return appStore.getLayout();
      } catch (error) {
        console.log(error);
      }
    }
  },
});

const bus = inject('bus');
const showCreateContentDialog = ref(false);
const showCreateEmptyPostDialog = ref(false);
const selectedKeyword = ref(null);

bus.on('show-create-content', (value) => {
  selectedKeyword.value = value;
  showCreateContentDialog.value = true;
});

bus.on('show-create-empty-post', (value) => {
  selectedKeyword.value = value;
  showCreateEmptyPostDialog.value = true;
});

async function getPosts() {
  try {
    await blogStore.getPosts({
      page: 1,
      perPage: route.name === ROUTES.DASHBOARD ? 5 : 12,
    });
  } catch (error) {
    console.error(error);
  }
}

function onHideCreateContentDialog() {
  selectedKeyword.value = null;
  showCreateContentDialog.value = false;
  getPosts();
}

function onHideCreateEmptyPostDialog() {
  selectedKeyword.value = null;
  showCreateEmptyPostDialog.value = false;
}

function addSupportWidgetScript() {
  if (process.env.CLIENT) {
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=d7b7a2d5-70a6-4473-9c06-9dfaf6f4b1e0';
    document.body.append(script);

    window.zESettings = {
      webWidget: {
        position: { horizontal: 'right', vertical: 'bottom' },
        zIndex: 6000,
      },
    };
  }
}

addSupportWidgetScript();
</script>

<style>
@import 'https://fonts.googleapis.com/css2?family=Mitr:wght@200;300;400;500;600;700&display=swap';
@import "../css/regular.css";

html, body, #q-app {
  font-family: 'Mitr', sans-serif;
}
</style>
